import { Box, Flex, Heading, HStack, Text } from '@chakra-ui/react';
import { ReportingRequirementOptionsViewModel, UpdateActivityReportingRequirementsModel } from '../types';
import { BaseCard, BaseFields, BaseHelpText, SelectOption } from '@invara-dev/react-base';
import { ArrayPath, UseFormReturn } from 'react-hook-form';
import { useState } from 'react';

type Props = {
  options: ReportingRequirementOptionsViewModel[];
  formMethods: UseFormReturn<UpdateActivityReportingRequirementsModel>;
  fieldArrayPath: ArrayPath<UpdateActivityReportingRequirementsModel>;
  fieldArrayIndex: number;
  isDisabled: boolean;
  onChange: (values: Array<string | undefined>) => void;
};

export const ReportingRequirementOptionInput = (props: Props) => {
  const [selectedValues, setSelectedValues] = useState<Array<string | undefined>>([]);

  const getInputOptions = (options: ReportingRequirementOptionsViewModel): SelectOption[] => {
    return options.Options.sort((a, b) => a.Order - b.Order).map((val) => {
      return { Label: val.Name, Value: val.Name, DescriptionLines: [val.Description] };
    });
  };

  return (
    <Box w={'100%'}>
      <BaseCard
        header={
          <Heading size={'sm'} p={'2px'}>
            <HStack>
              <Box>Prefill Options</Box>
              <BaseHelpText
                text={
                  <Box>
                    <Heading size={'xs'}>Prefill Options</Heading>
                    <Text>
                      Select options from the dropdowns below to prefill the value. <br />
                      <br /> You may modify the value after selection by typing in the text box.
                    </Text>
                  </Box>
                }
              />
            </HStack>
          </Heading>
        }
        w={'100%'}
        backgroundColor={'rgb(243, 243, 243)'}
        p={'4px'}>
        <Flex gap={'4px'} w={'100%'} justifyContent={'space-between'}>
          {props.options
            .sort((a, b) => a.GroupingPosition - b.GroupingPosition)
            .map((val, key) => {
              return (
                <Box key={key} flex={1}>
                  <Box w={'100%'} flex={1}>
                    <BaseFields.SelectInput
                      options={getInputOptions(val)}
                      onChangeControlled={(val) => {
                        const currentValues = [...selectedValues];
                        currentValues[key] = val?.toString();
                        setSelectedValues(currentValues);
                        props.onChange(currentValues);
                      }}
                      placeholder={val.GroupingName}
                      value={selectedValues[key]}
                    />
                  </Box>
                </Box>
              );
            })}
        </Flex>
      </BaseCard>
    </Box>
  );
};
